import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';

const BrandSafetyPanel = ({ blacklist, onAddToBlacklist, onRemoveFromBlacklist, safetySettings, onUpdateSettings }) => {
  const [newKeyword, setNewKeyword] = useState('');

  const handleAddKeyword = () => {
    if (newKeyword?.trim()) {
      onAddToBlacklist(newKeyword?.trim());
      setNewKeyword('');
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center gap-2 mb-6">
        <Icon name="Shield" size={20} className="text-primary" />
        <h2 className="text-lg font-semibold text-foreground">Brand Safety</h2>
      </div>
      <div className="space-y-6">
        <div>
          <h3 className="text-sm font-medium text-foreground mb-3">Safety Settings</h3>
          <div className="space-y-3">
            <Checkbox
              label="Avoid controversial topics"
              description="Skip posts about politics, religion, etc."
              checked={safetySettings?.avoidControversial}
              onChange={(e) => onUpdateSettings({ ...safetySettings, avoidControversial: e?.target?.checked })}
            />
            <Checkbox
              label="Sentiment analysis"
              description="Analyze post sentiment before commenting"
              checked={safetySettings?.sentimentAnalysis}
              onChange={(e) => onUpdateSettings({ ...safetySettings, sentimentAnalysis: e?.target?.checked })}
            />
            <Checkbox
              label="Competitor monitoring"
              description="Avoid commenting on competitor posts"
              checked={safetySettings?.competitorMonitoring}
              onChange={(e) => onUpdateSettings({ ...safetySettings, competitorMonitoring: e?.target?.checked })}
            />
          </div>
        </div>

        <div>
          <h3 className="text-sm font-medium text-foreground mb-3">Keyword Blacklist</h3>
          <div className="flex gap-2 mb-3">
            <Input
              type="text"
              placeholder="Add keyword to blacklist"
              value={newKeyword}
              onChange={(e) => setNewKeyword(e?.target?.value)}
              onKeyPress={(e) => e?.key === 'Enter' && handleAddKeyword()}
            />
            <Button
              variant="default"
              iconName="Plus"
              onClick={handleAddKeyword}
            >
              Add
            </Button>
          </div>
          <div className="flex flex-wrap gap-2">
            {blacklist?.map((keyword, index) => (
              <div key={index} className="flex items-center gap-2 px-3 py-1 bg-error/10 text-error rounded-lg">
                <span className="text-sm">{keyword}</span>
                <button
                  onClick={() => onRemoveFromBlacklist(keyword)}
                  className="hover:opacity-70 transition-opacity"
                >
                  <Icon name="X" size={14} />
                </button>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-muted rounded-lg p-4">
          <div className="flex items-start gap-3">
            <Icon name="Info" size={20} className="text-primary flex-shrink-0 mt-0.5" />
            <div>
              <p className="text-sm font-medium text-foreground mb-1">Safety Score</p>
              <p className="text-xs text-muted-foreground">
                Your current safety settings provide a {safetySettings?.avoidControversial && safetySettings?.sentimentAnalysis ? 'high' : safetySettings?.avoidControversial || safetySettings?.sentimentAnalysis ? 'medium' : 'basic'} level of brand protection. Enable all features for maximum safety.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrandSafetyPanel;